<template>
  <div>
    <b-button-group class="btnGroup">
      <b-button id="btnBack" class="buttons" @click="goBack">
        Back
      </b-button>
      <b-button id="btnPrint" class="buttons" @click="printStatement">
        Print
      </b-button>
    </b-button-group>
    <div id="statementBox"
      v-html="webPageResponse"
      :style="{ fontSize: fonts.font10 + 'px' }"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'z-showStatement',
  watch: {
    stateCC() {
      // this.writeDiag('watch stateCC triggered');
      this.$forceUpdate();
    },
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    statements() {
      return this.$store.getters.getStatements;
    },
    stateCC() {
      return this.$store.getters.getSTcc;
    },
    webPageResponse() {
      return this.$store.getters.webPageResponse;
    },
  },
  methods: {
    goBack() {
      window.history.back();
    },
    printStatement() { // [120] Added
      this.$htmlToPaper('statementBox');
    },
  },
};

</script>

<style scoped>
  .btnGroup {
    position: relative;
    width: 100%;
    height: 36px;
  }
  .buttons {
    position: absolute;
    top: 4px;
    height: 25px;
    width: 75px;
    padding: 0px;
  }
  #btnBack {
    left: 4px;
    background-color: red;
    color: black;
  }
  #btnPrint {
    left: 84px;
    background-color: lime;
    color: black;
  }
  #statementBox {
    border: solid 1px black;
  }

</style>



// WEBPACK FOOTER //
// src/components/showStmt.vue